var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2497 10.5V5.25C12.2497 4.28351 13.0332 3.5 13.9997 3.5H34.9997C35.9662 3.5 36.7497 4.28351 36.7497 5.25V29.75C36.7497 30.7165 35.9662 31.5 34.9997 31.5H29.7497V36.7484C29.7497 37.7158 28.9623 38.5 27.9878 38.5H7.01166C6.03853 38.5 5.25 37.7219 5.25 36.7484L5.25455 12.2515C5.25472 11.2842 6.04212 10.5 7.01648 10.5H12.2497ZM15.7497 10.5H29.7497V28H33.2497V7H15.7497V10.5ZM12.2497 19.25V22.75H22.7497V19.25H12.2497ZM12.2497 26.25V29.75H22.7497V26.25H12.2497Z",
    fill: "#3772FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIcon);
export default __webpack_public_path__ + "static/media/cloneIcon.89721a86.svg";
export { ForwardRef as ReactComponent };